<div id="editingBoxWrapper">
  <div class="filters associated">
    <div class="recorddetailpage-container" *ngFor="let column of store.cumulativeColumns">
      <!-- LABEL -->
      <!-- TODO: allow pin/unpin -->
      <miq-record-detail-label [column]="column" [disablePinEvent]="true"></miq-record-detail-label>
      <!-- INPUT -->
      <ng-container *ngIf="column.unit; else singleField">
        <miq-uom-record-detail-inputs
          [recordDetail]="column"
          [record]="store.record"
          (rdChange)="validate($event)"
          [isNewRecord]="store.isNewRecord"
        >
        </miq-uom-record-detail-inputs>
      </ng-container>

      <!-- SINGLE FIELD -->
      <ng-template #singleField>
        <ng-container
          *ngIf="
            !!column.templateRefName && !!templateInput[column.templateRefName];
            then customInput;
            else regularInput
          "
        ></ng-container>

        <ng-template #customInput>
          <ng-container
            *ngTemplateOutlet="templateInput[column.templateRefName]; context: { column: column }"
          ></ng-container>
        </ng-template>
        <ng-template #regularInput>
          <miq-editing-box-field
            [record]="store.record"
            [column]="column"
            (modified)="change($event)"
          ></miq-editing-box-field>
        </ng-template>
      </ng-template>
    </div>
    <ng-container *ngIf="store.errors$ | async as errors">
      <span class="error" *ngFor="let error of errors">{{ error | xTranslate }}</span>
    </ng-container>
    <div class="actions-bar">
      <ng-container *ngIf="showAutoSumCtrl">
        <mat-checkbox id="e2e-auto-sum-checkbox" [formControl]="enableAutoSumCtrl">
          {{ 'recordsSearch.autosum' | xTranslate }} {{ store.totalColumn.header }}
        </mat-checkbox>
      </ng-container>

      <a (click)="closeBox()" [ngClass]="{ disabled: !valid }">
        <mat-icon class="link-icon" svgIcon="done-icon"></mat-icon>
        <span l10nTranslate>shared.done</span>
      </a>
    </div>
  </div>
</div>
